/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import PropTypes, { number } from "prop-types";
import Progress from "./Progress";
import axios from "axios";

import { Box, Button, Container } from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import SendIcon from '@mui/icons-material/Send';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CustomTextField from "./CustomTextField";
import CustomSelect from "./CustomSelect";
import CustomCheckbox from "./CustomCheckbox";
import Divider from '@mui/material/Divider';

import { getDescriptionItems, getDocumentType, documentFormats, agencyDocsTypesList, journalTypesList, producerDocsTypesList, hrTypeList, beaconCompanyList, bondsCompanyList, rtwSystemCompanyList, largeLineDecCompanyList, itvProjectCompanyList, redDealTypeList, hrcreditcardtypemenu, investmentsecurities, investmentCUSIP, investmentslist, dateofLoss, auditTypeList, auditItemList, bnkReconCorpTypeList, bnkReconCorpIndexList, bnkReconBRTypeList, bnkReconBRIndexList, accountingTypeList, acctReconTypeList, acctReconIndexList, rhodeTypeList, reinsuranceTypeList, r3ContractTypeList, policyComplainTypeList, currentCarrierList, lossControlTypeList, leaseTypeList, commTypeList, contractTypeList, billDataTypeList, claimDataTypeList, empFileCompanyList, hrMvrTypeList, hrRelocateTypeList, policyFormTypeList, adjFileRegionList, adminFormTypeList, adminEnvTypeList, assnCorpReportsList, assnProgTypeList, assnCorpTypeList } from "./fields";
import { checkcreditcardemployeenumber, checkpolicyNumber, checkpolicySymbol, checkIdentifier, checkagencynumber, checkbeaconsystempolicynumber, checklocation, checkbondspolicynumber, checkpatrons, checkpolicydeclineinsuredname, checkproducercode, checkrtwpolicynumber, checkcheckrange, checkssn, checkproducernumber, checkyear, checkinternalaudituserid, checkrhodepolicynumber, checkdoctypepolicynumber } from "./utils"
import { xlmgenerator } from "./docxml";

const CryptoJS = require('crypto-js');
// import { config } from './config'

let fontSize = 13;
let ATTACHMENTS = [];
// let envarr = config

const validationFunctions = {
  policysymbol: checkpolicySymbol,
  policynumber: checkpolicyNumber,
  userid: checkpolicyNumber, // Assuming the same validation function as policynumber
  identifier: checkIdentifier,
  agencynumber: checkagencynumber,
  assnnumber: checkagencynumber, // Assuming the same validation function as agencynumber
  bondspolicynumber: checkbondspolicynumber,
  beaconsystempolicynumber: checkbeaconsystempolicynumber,
  location: checklocation,
  formnumber: checklocation, // Assuming the same validation function as location
  completepolicynumber: checkpatrons,
  employeefilepolicynumber: checkpatrons, // Assuming the same validation function as patronspolicynumber
  insuredname: checkpolicydeclineinsuredname,
  producercode: checkproducercode,
  rtwpolicynumber: checkrtwpolicynumber,
  checkrange: checkcheckrange,
  itvpolicynumber: checkpatrons, // Assuming the same validation function as patronspolicynumber
  largelinedecpolicynumber: checkpatrons, // Assuming the same validation function as patronspolicynumber
  employeenumber: checkagencynumber, // Assuming the same validation function as agencynumber
  ssn: checkssn,
  producernumber: checkproducernumber,
  year: checkyear,
  internalaudituserid: checkinternalaudituserid,
  rhodepolicynumber: checkrhodepolicynumber,
  creditcardemployeenumber: checkcreditcardemployeenumber,
  claimnumber:checkpolicyNumber,
  claimsymbol:checkpolicySymbol,
  doctypepolicynumber:checkdoctypepolicynumber,
};

function handleAttachments(item) {
  const options = { asyncContext: { currentItem: item } };
  if (item.attachments.length > 0) {
    for (const element of item.attachments) {
      item.getAttachmentContentAsync(element.id, options, handleAttachmentsCallback);
    }
  }
}

function handleAttachmentsCallback(result) {
  switch (result.value.format) {
    case Office.MailboxEnums.AttachmentContentFormat.Base64:
      ATTACHMENTS.push(result.value);
      break;
    case Office.MailboxEnums.AttachmentContentFormat.Eml:
      console.log("// Handle email item attachment.");
      break;
    case Office.MailboxEnums.AttachmentContentFormat.ICalendar:
      console.log("// Handle .icalender attachment.");
      break;
    case Office.MailboxEnums.AttachmentContentFormat.Url:
      console.log("// Handle cloud attachment.");
      break;
    default:
      console.log("// Handle attachment formats that are not supported.");
  }
}

export default class App extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      listItems: [],
      documentType: "",
      description: "",
      documentTypeInvalid: false,
      attachments: [],
      mailContent: "",
      totalAttachmentSize: number,
      wrongFormats: true,
      journaltype: "",
      type: "",
      policynumber: "",
      policysymbol: "",
      identifier: "",
      agencynumber: "",
      beaconsystempolicynumber: "",
      dateofloss: "",
      claimsymbol: "",
      claimsymbolInvalid: false,
      claimnumberInvalid: false,
      claimnumber: "",
      referenceinformation: "",
      employeenumber: "",
      location: "",
      agencyname: "",
      insuredname: "",
      producercode: "",
      reddealcompany: "",
      checkrange: "",
      ssn: "",
      policysymbolInvalid: false,
      policynumberInvalid: false,
      identifierInvalid: false,
      agencynumberInvalid: false,
      beaconsystempolicynumberInvalid: false,
      bondspolicynumber: "",
      bondspolicynumberInvalid: false,
      locationInvalid: false,
      completepolicynumber: "",
      completepolicynumberInvalid: false,
      insurednameInvalid: false,
      producercodeInvalid: false,
      rtwpolicynumberInvalid: false,
      rtwpolicynumber: "",
      checkrangeInvalid: false,
      ssnInvalid: false,
      producernumberInvalid: false,
      producernumber: "",
      states: "",
      company: "",
      userid: "",
      useridInvalid: false,
      year: "",
      yearInvalid: false,
      internalaudituserid: "",
      internalaudituseridInvalid: false,
      rhodepolicynumber: "",
      rhodepolicynumberInvalid: false,
      documentTypes: [],
      id: null,
      permissionsData: null,
      uploadStarted: false,
      uploadEnded: false,
      presigned: null,
      attachmentData: [],
      mailSentSuccessfully: false,
      mailSending: false,
      creditcardemployeenumber: "",
      creditcardemployeenumberInvalid: false,
      doctypepolicynumber: "",
      doctypepolicynumberInvalid: false,
    };
  }

  componentDidUpdate() {
    if (this.state.permissionsData === null) {
      this.checkUserID();
    }
    if (this.state.mailSentSuccessfully === true) {
      setTimeout(() => {
        Office.context.ui.closeContainer();
      }, 10000);
    }
  }

  async checkUserID() {
    const id = Office.context.mailbox.userProfile.emailAddress.toLowerCase()
    this.setState({ id: id });
    let getType = {
      user_group: id
    }
    const headers = {
      "x-api-key": process.env.API_KEY,
    }
    // console.log(headers)
    try {
      // console.log(process.env.API_URL + "UserGroupDocuments")
      const response = await axios.post(process.env.API_URL + "UserGroupDocuments", getType, { headers: headers });
      this.setState({ permissionsData: response.data });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  resetState = () => {
    this.setState({
      listItems: [],
      documentType: "",
      description: "",
      documentTypeInvalid: false,
      attachments: [],
      mailContent: "",
      totalAttachmentSize: number,
      wrongFormats: true,
      journaltype: "",
      type: "",
      policynumber: "",
      policysymbol: "",
      identifier: "",
      agencynumber: "",
      beaconsystempolicynumber: "",
      dateofloss: "",
      claimsymbol: "",
      claimsymbolInvalid: false,
      claimnumberInvalid: false,
      claimnumber: "",
      referenceinformation: "",
      employeenumber: "",
      location: "",
      agencyname: "",
      insuredname: "",
      producercode: "",
      reddealcompany: "",
      checkrange: "",
      ssn: "",
      policysymbolInvalid: false,
      policynumberInvalid: false,
      identifierInvalid: false,
      agencynumberInvalid: false,
      beaconsystempolicynumberInvalid: false,
      bondspolicynumber: "",
      bondspolicynumberInvalid: false,
      locationInvalid: false,
      completepolicynumber: "",
      completepolicynumberInvalid: false,
      insurednameInvalid: false,
      producercodeInvalid: false,
      rtwpolicynumberInvalid: false,
      rtwpolicynumber: "",
      checkrangeInvalid: false,
      ssnInvalid: false,
      producernumberInvalid: false,
      producernumber: "",
      states: "",
      company: "",
      userid: "",
      useridInvalid: false,
      year: "",
      yearInvalid: false,
      internalaudituserid: "",
      internalaudituseridInvalid: false,
      rhodepolicynumber: "",
      rhodepolicynumberInvalid: false,
      documentTypes: [],
      id: null,
      permissionsData: null,
      uploadStarted: false,
      uploadEnded: false,
      presigned: null,
      attachmentData: [],
      mailSentSuccessfully: false,
      mailSending: false,
      creditcardemployeenumber: "",
      creditcardemployeenumberInvalid: false,
      doctypepolicynumber: "",
      doctypepolicynumberInvalid: false,
    });
  };

  checkFiletype = (att) => {
    let rightf = false;
    att.forEach((attach) => {
      let fname = attach.value;
      let temparra = fname.split(".");
      let fformat = temparra[1];
      if (documentFormats.some((element) => element.value === fformat)) {
        rightf = true;
      } else {
        rightf = false;
      }
    });
    this.state.wrongFormats = !rightf;
  };

  onChangedocumentType = (e, item) => {
    ATTACHMENTS = [];
    handleAttachments(item);
    item.body.getAsync(Office.CoercionType.Text, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        this.setState({ mailContent: result.value });
        let att = [];
        let attSizes = 0;
        item.attachments.map((attach) =>
          att.push({
            id: attach.id,
            value: attach.name,
            isChecked: true,
            size: attach.size,
            mimeType: attach.contentType,
          })
        );
        this.checkFiletype(att);
        att.map((i) => (attSizes = attSizes + i.size));
        this.setState({ totalAttachmentSize: attSizes });
        ATTACHMENTS.map((hash, indx) => {
          att[indx]["hash"] = hash.content;
        });
        this.setState({ attachments: att });
      } else {
        this.setState({ mailContentError: bodyResult.error.message });
        console.log(bodyResult.error.message);
      }
    });
    this.setState({ documentType: e.target.value });
    // console.log("ATTACHMENTS", this.state.attachments)
    this.attachmentSend_alt(item)

    try {
      // console.log("the env variabsdfles are:", (process.env))
      // console.log("the temp env variables are:", process.env.REACT_APP_TEST_ENV_VAR)
      // console.log("the temp env variables are:", process.env.REACT_APP_API_URL)
      // console.log("the temp env variables are:", process.argv)

    }
    catch (error) {
      console.log("error when defining", error)
    }

  };

  updateDescription = (e, field) => {
    // console.log(" e.target.value ", field, e.target)
    this.setState({ [field]: e.target.value });
  };

  updateState = (e, field) => {
    this.setState({ [field]: e.target.value });
    // console.log(" e.target.value ", field, e.target.value)
    this.validateFields(e, field);
  };

  validateFields = (e, field) => {
    const validationFunction = validationFunctions[field];
    // console.log("validation",field, e.target.value)
    if (validationFunction) {
      this.state[`${field}Invalid`] = validationFunction(e.target.value);
      // console.log("this.state[`${field}Invalid`", field, this.state[`${field}Invalid`])
    }
  };

  updateAttachments = (e, item) => {
    // console.log("ATTACHMENTS", this.state.attachments)
    let newAtt = [...this.state.attachments];
    for (let i in newAtt) {
      if (newAtt[i].id == item.id) {
        newAtt[i].isChecked = e.target.checked;
        break;
      }
    }
    let newAtt2 = newAtt.filter((item) => item.isChecked === true);
    this.setState({ attachments: newAtt });
  };

  getAttachmentsWithBase64 = () => {
    let attachmentsWithBase64Data = this.state.attachments
      ? this.state.attachments.reduce((acc, attach) => {
        if (attach.isChecked) {
          acc.push({
            name: attach.value,
            mimeType: attach.mimeType,
            hash: attach.hash,
            size: attach.size,
          });
        }
        return acc;
      }, [])
      : [];

    return attachmentsWithBase64Data;
  };

  sendToSACC = (item, doctype, state) => {
    this.setState({ mailSending: true });
    const attachmentFiles = this.getAttachmentsWithBase64();
    let xmlren = ""
    xmlren = xlmgenerator(item, doctype, state)
    let usid = this.state.id

    // let postD = {
    //   from: "DoNotReply@stateauto.com",
    //   to: "send2mobius-l1@stateauto.com",
    //   cc: usid,
    //   subject: "Send2SACC Test Subject",
    //   body: this.state.mailContent,
    //   presigned_urls: this.state.presigned
    // }

    let postD = {
      from: "DoNotReply@stateauto.com",
      to: "S2MEmail@StateAuto.com",
      // to: "rituraj.kulshresth@stateauto.com",
      cc: usid,
      subject: item.subject,
      body: this.state.mailContent,
      presigned_urls: this.state.presigned
    }

    postD.body = postD.body + "\n\n" + "This submission has been sent by " + this.state.id + " " + Office.context.mailbox.userProfile.displayName
    postD.body = postD.body + "\n\n" + xmlren;
    console.log(postD)
    let jsonString = JSON.stringify(postD)
    const headers = {
      "x-api-key": process.env.API_KEY
    }
    axios.post(process.env.API_URL + "SendEmail", jsonString, { headers: headers }).then((response) => {
      console.log(response)
      if (response.status === 200) {
        this.setState({ mailSentSuccessfully: true });
      }
    })
  }

  renderContent() {
    switch (this.state.documentType) {
      case "Policy":
        return (
          <>
            <CustomTextField
              // value={this.state.policySymbol}
              label="POLICY SYMBOL"
              defaultValue={this.state.policysymbol}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.policysymbolInvalid}
              helperText={this.state.policysymbolInvalid ? "Please Enter the correct policy Symbol (ABC, AB, or A)" : ""}
            />
            <CustomTextField
              // value={this.state.policyNumber}
              label="DOCTYPE POLICY NUMBER"
              defaultValue={this.state.doctypepolicynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.doctypepolicynumberInvalid}
              helperText={this.state.doctypepolicynumberInvalid ? "Please Enter the correct policy Number (1234567)" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="DESCRIPTION"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
              error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Acctg_Journal":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              // defaultValue={this.state.journaltype}
              label="Type"
              menuItem={journalTypesList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomTextField
              label="Identifier"
              defaultValue={this.state.identifier}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.identifierInvalid}
              helperText={this.state.identifierInvalid ? "Please Enter the correct Identifier AAA####-### (IE ABC1234-123)" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.identifier)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Delinquent_Let":
      case "Agency":
        return (
          <>
            <CustomTextField
              // value={this.state.policyNumber}
              label="Agency Number"
              defaultValue={this.state.agencynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.agencynumberInvalid}
              helperText={this.state.agencynumberInvalid ? "Please enter 7 digit numeric agency code" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Beacon_System":
        return (
          <>
            <CustomSelect
              value={this.state.company}
              label="Company"
              menuItem={beaconCompanyList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              // value={this.state.policyNumber}
              label="Beacon System Policy Number"
              defaultValue={this.state.beaconsystempolicynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.beaconsystempolicynumberInvalid}
              helperText={this.state.beaconsystempolicynumberInvalid ? "Please Enter a valid 11 Character Policy Symbol/Number. ('ABC 1234567')" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.beaconsystempolicynumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Bonds":
        return (
          <>
            <CustomSelect
              value={this.state.company}
              label="Company"
              menuItem={bondsCompanyList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Bonds Policy Number"
              defaultValue={this.state.bondspolicynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.bondspolicynumberInvalid}
              helperText={this.state.bondspolicynumberInvalid ? "Please Enter a valid 11 Character Policy Symbol/Number. ('SUR 1234567')" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.bondspolicynumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Claim":
        return (
          <>
            <CustomTextField
              label="Claim Symbol"
              defaultValue={this.state.claimsymbol}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.claimsymbolInvalid}
              helperText={this.state.claimsymbolInvalid ? "Please Enter the correct claim Symbol (ABC)" : ""}
            />
            <CustomTextField
              label="Claim Number"
              defaultValue={this.state.claimnumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.claimnumberInvalid}
              helperText={this.state.claimnumberInvalid ? "Please Enter the correct claim Number (1234567)" : ""}
            />
            <CustomSelect
              value={this.state.dateofloss}
              label="Date of Loss"
              menuItem={dateofLoss}
              onChangeFunc={this.updateState}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "ECA_Security":
        return (
          <>
            <CustomTextField
              label="Reference Information"
              defaultValue={this.state.referenceinformation}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
            <CustomTextField
              label="Employee Number"
              defaultValue={this.state.employeenumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.employeenumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Investments":
        return (
          <>
            <CustomSelect
              value={this.state.company}
              label="Company"
              menuItem={investmentCUSIP || undefined}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={investmentslist || undefined}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            {
              this.state.type === "CUSIP" && (
                <>
                  <CustomTextField
                    label="Description"
                    defaultValue={this.state.description}
                    fontSize={fontSize}
                    inputProps={{ readOnly: false, disableUnderline: false }}
                    onBlurFunc={this.updateState}
                    helperText={"Please enter 9 characters only"}
                  // add validation length 9
                  />
                </>
              )
            }
            {
              this.state.type === "Securities_on_Deposit" && (
                <>
                  <CustomSelect
                    value={this.state.states}
                    label="States"
                    menuItem={investmentsecurities || undefined}
                    onChangeFunc={this.updateDescription}
                    onBlurFunc={this.validateFields}
                  />
                </>
              )
            }
            {
              this.state.type === "Trust_Docs" && (
                <>
                  <CustomSelect
                    value={this.state.description}
                    label="Description"
                    menuItem={getDescriptionItems(this.state.documentType)}
                    onChangeFunc={this.updateDescription}
                    onBlurFunc={this.validateFields}
                  />
                </>
              )
            }
          </>
        );
      case "Owned_Prop":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={[{ key: "Owned", value: "Owned" }]}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Location"
              defaultValue={this.state.location}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.locationInvalid}
              helperText={this.state.locatonInvalid ? "Please Enter the correct location" : ""}

            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Patrons_System":
        return (
          <>
            <CustomSelect
              value={this.state.company}
              label="Company"
              menuItem={bondsCompanyList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Complete Policy Number"
              defaultValue={this.state.completepolicynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.completepolicynumberInvalid}
              helperText={this.state.completepolicynumberInvalid ? "Please Enter the correct Policy Number" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.completepolicynumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Policy_Decline":
        return (
          <>
            <CustomTextField
              label="Insured Name"
              defaultValue={this.state.insuredname}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.insurednameInvalid}
              helperText={this.state.insurednameInvalid ? "Please Enter the name in 29 character" : ""}
            />
            <CustomTextField
              label="Agency Name"
              defaultValue={this.state.agencyname}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
          </>
        );
      case "Producer":
        return (
          <>
            <CustomTextField
              label="Producer Code"
              defaultValue={this.state.producercode}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.producercodeInvalid}
              helperText={this.state.producercodeInvalid ? "Please Enter the producercode" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Red_Deal":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={redDealTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            {this.state.type && (
              <>
                <CustomTextField
                  label="Company"
                  defaultValue={this.state.reddealcompany}
                  fontSize={fontSize}
                  inputProps={{ readOnly: false, disableUnderline: false }}
                  onBlurFunc={this.updateState}
                />
                <CustomSelect
                  value={this.state.description}
                  label="Description"
                  menuItem={getDescriptionItems(this.state.documentType, this.state.type)}
                  onChangeFunc={this.updateDescription}
                  onBlurFunc={this.validateFields}
                // error={this.state.documenttypeInvalid}
                />
              </>
            )}
          </>
        );
      case "RTW_System":
        return (
          <>
            <CustomSelect
              value={this.state.company}
              label="Company"
              menuItem={rtwSystemCompanyList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="RTW Policy Number"
              defaultValue={this.state.rtwpolicynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.rtwpolicynumberInvalid}
              helperText={this.state.rtwpolicynumberInvalid ? "Please Enter the policy Numbner ('AA-AA-999999')" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.rtwpolicynumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "AP_Docs":
        return (
          <>
            <CustomTextField
              label="Reference Information"
              defaultValue={this.state.referenceinformation}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
            <CustomTextField
              label="Check Range"
              defaultValue={this.state.checkrange}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.checkrangeInvalid}
              helperText={this.state.checkrangeInvalid ? "Please enter Check Range as 10-10 EFT,DISB, PRRFD, CARD, GWPRF, OR RPRFD Example: (0000123456 EFT or 0000123456-0000789108 PRRFD)" : ""}
            />
            {/* // the description here has only one option named %itemcode% */}

            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.checkrange)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "ITV_Project":
        return (
          <>
            <CustomSelect
              value={this.state.company}
              label="Company"
              menuItem={itvProjectCompanyList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Complete Policy Number"
              defaultValue={this.state.completepolicynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.completepolicynumberInvalid}
              helperText={this.state.completepolicynumberInvalid ? "Please Enter a valid 11 Character Policy Symbol/Number. ('ABC 1234567', 'AB  1234567' or 'A   1234567')" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.completepolicynumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Large_Line_Dec":
        return (
          <>
            <CustomSelect
              value={this.state.company}
              label="Company"
              menuItem={largeLineDecCompanyList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Complete Policy Number"
              defaultValue={this.state.completepolicynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.completepolicynumberInvalid}
              helperText={this.state.completepolicynumberInvalid ? "Please Enter a valid 11 Character Policy Symbol/Number. ('ABC 1234567', 'AB  1234567' or 'A   1234567')" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.completepolicynumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "HR_Credit_Card":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={hrcreditcardtypemenu}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Credit Card Employee Number"
              defaultValue={this.state.creditcardemployeenumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.creditcardemployeenumberInvalid}
              helperText={this.state.creditcardemployeenumberInvalid ? "Please Enter the emploayee number 6 dig" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "HR":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={hrTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            {this.state.type && (
              <>
                <CustomTextField
                  label="SSN"
                  defaultValue={this.state.ssn}
                  fontSize={fontSize}
                  inputProps={{ readOnly: false, disableUnderline: false }}
                  onBlurFunc={this.updateState}
                  error={this.state.ssnInvalid}
                  helperText={this.state.ssnInvalid ? "Please Enter the SSN number NNN-NN-NNNN" : ""}
                />
                <CustomSelect
                  value={this.state.description}
                  label="Description"
                  menuItem={getDescriptionItems(this.state.documentType, this.state.type)}
                  onChangeFunc={this.updateDescription}
                  onBlurFunc={this.validateFields}
                // error={this.state.documenttypeInvalid}
                />
              </>
            )}

          </>
        );
      case "Agency_Docs":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={agencyDocsTypesList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomTextField
              label="Agency Number"
              defaultValue={this.state.agencynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.agencynumberInvalid}
              helperText={this.state.agencynumberInvalid ? "Please Enter the Agency Number" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.agencynumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Producer_Docs":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={producerDocsTypesList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomTextField
              label="Producer Number"
              defaultValue={this.state.producernumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.producernumberInvalid}
              helperText={this.state.producernumberInvalid ? "Please Enter the Producer Number 7 dig" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.producernumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Assn_Corporate":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={assnCorpTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomSelect
              value={this.state.reports}
              label="Reports"
              menuItem={assnCorpReportsList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.type)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Assn_Programs":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={assnProgTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="ASSN Number"
              defaultValue={this.state.agencynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.agencynumberInvalid}
              helperText={this.state.agencynumberInvalid ? "Please Enter the 4 digit ASSN number " : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.type)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Admin_Envelopes":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={adminEnvTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Envelope Number"
              defaultValue={this.state.reddealcompany}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Admin_Forms":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={adminFormTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Form Number"
              defaultValue={this.state.reddealcompany}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Adj_Files":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Region"
              menuItem={adjFileRegionList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Name (Last First)"
              defaultValue={this.state.reddealcompany}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Policy_Forms":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={policyFormTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Form Number"
              defaultValue={this.state.location}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              error={this.state.locationInvalid}
              onBlurFunc={this.updateState}
              helperText={this.state.locatonInvalid ? "Please enter up to 10 characters - 6 character date (ACCORD1234-200402)" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.location)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "HR_Relocate":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={hrRelocateTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Employee Number"
              defaultValue={this.state.agencynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.agencynumberInvalid}
              helperText={this.state.agencynumberInvalid ? "Please enter a 6 digit numeric employee number" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "HR_MVR":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={hrMvrTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Employee Number"
              defaultValue={this.state.agencynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.agencynumberInvalid}
              helperText={this.state.agencynumberInvalid ? "Please enter a 6 digit numeric employee number" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Employee_File":
        return (
          <>
            <CustomSelect
              value={this.state.company}
              label="Company"
              menuItem={empFileCompanyList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Complete Policy Number"
              defaultValue={this.state.completepolicynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.completepolicynumberInvalid}
              helperText={this.state.completepolicynumberInvalid ? "Please Enter the correct Policy Number" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.completepolicynumber)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Claim_Data":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={claimDataTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="User ID"
              defaultValue={this.state.userid}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.useridInvalid}
              helperText={this.state.useridInvalid ? "Please Enter the correct Policy Number" : ""}
            />
            <CustomTextField
              label="Description"
              defaultValue={""}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
          </>
        );
      case "Bill_Data":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={billDataTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="User ID"
              defaultValue={""}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.useridInvalid}
              helperText={this.state.useridInvalid ? "Please Enter the correct Policy Number" : ""}
            />
            <CustomTextField
              label="Description"
              defaultValue={""}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
          </>
        );
      case "Contracts":
        return (
          <>
            <CustomSelect
              value={this.state.contractType}
              label="Contract Type"
              menuItem={contractTypeList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomTextField
              label="User ID"
              defaultValue={""}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.useridInvalid}
              helperText={this.state.useridInvalid ? "Please Enter the correct Policy Number" : ""}
            />
            <CustomTextField
              label="Description"
              defaultValue={this.state.description}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
          </>
        );
      case "Comm_Adjust":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={commTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomTextField
              label="User ID"
              defaultValue={this.state.policynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.policynumberInvalid}
              helperText={this.state.policynumberInvalid ? "Please enter a 7 digit Agency number only" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "DC_Audit":
        return (
          <>
            <CustomTextField
              label="Year"
              defaultValue={this.state.year}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.yearInvalid}
              helperText={this.state.yearInvalid ? "Please enter a valid year" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      // case "Delinquent_Let":
      // return (
      //   <>
      //     <CustomTextField
      //       label="Agency Number"
      //       defaultValue={this.state.agencynumber}
      //       fontSize={fontSize}
      //       inputProps={{ readOnly: false, disableUnderline: false }}
      //       onBlurFunc={this.updateState}
      //       error={this.state.agencynumberInvalid}
      //       helperText={this.state.agencynumberInvalid ? "Please enter 7 digit numeric agency code" : ""}
      //     />
      //     <CustomSelect
      //       value={this.state.description}
      //       label="Description"
      //       menuItem={getDescriptionItems(this.state.documentType)}
      //       onChangeFunc={this.updateDescription}
      //       onBlurFunc={this.validateFields}
      //     />
      //   </>
      // );
      case "Internal_Audit":
        return (
          <>
            <CustomTextField
              label="Internal Audit User ID"
              defaultValue={this.state.internalaudituserid}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.internalaudituseridInvalid}
              helperText={this.state.internalaudituseridInvalid ? "Please enter user ID in format of AAA1234 or AA1234" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Lease":
        return (
          <>
            <CustomSelect
              value={this.state.leaseType}
              label="Type"
              menuItem={leaseTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomTextField
              label="Lease Number"
              defaultValue={this.state.location}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.locationInvalid}
              helperText={this.state.locationInvalid ? "Enter Correct Lease Number" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.leaseType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Loss_Control_Reg":
        return (
          <>
            <CustomSelect
              value={this.state.lossControlType}
              label="Loss Control Type"
              menuItem={lossControlTypeList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.lossControlItem}
              label="Item"
              menuItem={lossControlItemList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Description"
              defaultValue={this.state.description}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />

          </>
        );
      case "Policy_Complaint":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={policyComplainTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomTextField
              label="Policy Number"
              defaultValue={this.state.location}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.locationInvalid}
              helperText={this.state.locationInvalid ? "Your Policy Number Format is not Valid" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.type)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "R3_Contracts":
        return (
          <>
            <CustomSelect
              value={this.state.contractType}
              label="Contract Type"
              menuItem={r3ContractTypeList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomTextField
              label="Contract ID"
              defaultValue={this.state.type}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
            <CustomTextField
              label="Description"
              defaultValue={this.state.description}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
          </>
        );
      case "ReIns_Assumed":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="ReInsurance Type"
              menuItem={reinsuranceTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Company Name"
              defaultValue={this.state.location}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.locationInvalid}
              helperText={this.state.locationInvalid ? "Please enter 1-29 character company name" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // // the description here has only one option named %itemcode%
            />
          </>
        );
      case "Rhode_Is_AIP":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={rhodeTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Rhode Policy Number"
              defaultValue={this.state.rhodepolicynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.rhodepolicynumberInvalid}
              helperText={this.state.rhodepolicynumberInvalid ? "Please enter a 9 digit Policy number beginning with R" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // // the description here has only one option named %itemcode%
            />
          </>
        );
      case "Acct_Recon":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Index"
              menuItem={acctReconIndexList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.type}
              label="Type"
              menuItem={acctReconTypeList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Description"
              defaultValue={this.state.description}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
          </>
        );
      case "Acctg_Agency":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Accounting Type"
              menuItem={accountingTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Agency Number"
              defaultValue={this.state.agencynumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
              error={this.state.agencynumberInvalid}
              helperText={this.state.agencynumberInvalid ? "Please enter a 7 digit Agency number only" : ""}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // // the description here has only one option named %itemcode%
            />
          </>
        );
      case "Bnk_Recon-BR":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Index"
              menuItem={bnkReconBRIndexList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.type}
              label="Branch"
              menuItem={bnkReconBRTypeList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Description"
              defaultValue={this.state.description}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />

          </>
        );
      case "Bnk_Recon-Corp":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Index"
              menuItem={bnkReconCorpIndexList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.type}
              label="Company"
              menuItem={bnkReconCorpTypeList}
              // onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Description"
              defaultValue={this.state.description}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
          </>
        );
      case "Audit_F_Drive":
      case "Audit_LADM":
      case "Audit_Mainframe":
      case "Audit_MB_Admin":
      case "Audit_MB_User":
      case "Audit_SharePoint":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Audit Type"
              menuItem={auditTypeList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
            <CustomSelect
              value={this.state.type}
              label="Item"
              menuItem={auditItemList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType, this.state.type)} //audit type
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            // error={this.state.documenttypeInvalid}
            />
          </>
        );
      case "Current_Carrier":
        return (
          <>
            <CustomSelect
              // value={this.state.type}
              label="Item"
              value={this.state.type}
              menuItem={currentCarrierList}
              onChangeFunc={(e) => { this.setState({ type: e.target.value }) }}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.type}
              label="Reports"
              menuItem={currentCarrierList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "Data_Quality":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Item"
              menuItem={dataQualityList}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );
      case "HR_LDR_COMP":
        return (
          <>
            <CustomSelect
              value={this.state.type}
              label="Item"
              menuItem={"HR LDR COMP"}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
            <CustomTextField
              label="Employee Number"
              defaultValue={this.state.employeenumber}
              fontSize={fontSize}
              inputProps={{ readOnly: false, disableUnderline: false }}
              onBlurFunc={this.updateState}
            />
            <CustomSelect
              value={this.state.description}
              label="Description"
              menuItem={getDescriptionItems(this.state.documentType)}
              onChangeFunc={this.updateDescription}
              onBlurFunc={this.validateFields}
            />
          </>
        );

    }

  }

  renderAttachmentInfo() {
    if (this.state.attachments.length === 0) {
      return null;
    }

    const totalAttachmentSizeMB = this.state.totalAttachmentSize / (1024 * 1024);

    return (
      <>
        {totalAttachmentSizeMB < 20 && (
          <div>Total Attachment size is {totalAttachmentSizeMB.toFixed(2)} MB</div>
        )}
        {totalAttachmentSizeMB >= 20 && (
          <div style={{ color: 'red' }}>Total attachment size is greater than 20 MB. Please reduce it.</div>
        )}
        {this.state.wrongFormats && (
          <div style={{ color: 'red' }}>Attachment is of an invalid file type. Please Check!!</div>
        )}
      </>
    );
  }

  async uploadAttachment_alt() {
    this.setState({ uploadStarted: true });
    let responseStatusSuccess = true;
    try {
      const datas = this.state.attachmentData.map((attdata) => ({
        name: attdata.attachment_name,
        data: attdata.data,
        url: this.state.presigned[this.state.attachmentData.indexOf(attdata)].presigned_url,
        sha: this.state.presigned[this.state.attachmentData.indexOf(attdata)].checksumSHA256,
      }));
      // console.log("Data inside upload attachments", datas);
      for (const attData of datas) {
        let maxTries = 3;
        let tryCount = 0;
        let response;

        while (tryCount < maxTries && (!response || response.status !== 200)) {
          try {
            // console.log(attData.url);
            // console.log(attData.sha);
            const byteCharacters = atob(attData.data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const customHeaders = {
              'x-amz-checksum-sha256': attData.sha,
            };
            response = await axios.put(attData.url, byteArray, {
              headers: customHeaders,
            });
            console.log("Response", response);
            if (response.status === 200) {
              responseStatusSuccess = true;
            } else {
              console.log(`Attempt ${tryCount + 1} failed. Retrying...`);
            }
          } catch (error) {
            console.error(`Attempt ${tryCount + 1} failed with error: ${error.message}. Retrying...`);
          }
          tryCount++;
        }
      }

      if (responseStatusSuccess) {
        this.setState({ uploadStarted: false });
        this.setState({ uploadEnded: true });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }


  async SHAMaker(attachmentData) {
    // console.log("Inside SHA Maker");
    const hashArrayPromises = attachmentData.map(async (attachment) => {
      const byteCharacters = atob(attachment.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const hashBuffer = await crypto.subtle.digest('SHA-256', byteArray);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

      // console.log("hashBuffer", hashBuffer);
      // console.log("hashArray",hashArray);
      // console.log("hashHex",hashHex);
      // console.log("Base64",btoa(hashHex))

      const hexBytes = hashHex.match(/.{1,2}/g); // Split the hex string into pairs of two characters
      const byteArray2 = new Uint8Array(hexBytes.map(byte => parseInt(byte, 16)));
      const base64String = btoa(String.fromCharCode(...byteArray2));

      // console.log("base64String", base64String)

      return base64String;
    });

    return Promise.all(hashArrayPromises);
  }


  async attachmentSend_alt(item) {
    // console.log("Url alt func")
    const fileNames = [];
    const attachmentData = [];
    // const SHAData=[];
    const attachmentPromises = item.attachments.map(async (attachment) => {
      return new Promise((resolve) => {
        item.getAttachmentContentAsync(attachment.id, async (result) => {
          const data = result.value.content;
          let spaceremovedname = attachment.name.replace(/[^a-zA-Z0-9.]/g, '')
          const sha = await this.SHAMaker([{ attachment_name: attachment.name, data }]);
          attachmentData.push({
            attachment_name: spaceremovedname,
            data,
            sha: sha[0], // Assuming there's only one SHA hash for each attachment
          });
          fileNames.push({
            file_name: spaceremovedname,
            checksumSHA256: sha[0],
          })
          // console.log(attachment.name);
          resolve();
        });
      });
    });

    await Promise.all(attachmentPromises);
    this.setState({ attachmentData: attachmentData })
    let s3UrlData2 = {
      "file_names": fileNames
    }

    let jsonString = JSON.stringify(s3UrlData2)
    // console.log("s3UrlData2", s3UrlData2)
    // console.log("jsonString", jsonString)
    const headers = {
      "x-api-key": process.env.API_KEY
    }
    let s3Url2 = await axios.post(process.env.API_URL + "GenerateS3PreSignedURL", jsonString, { headers: headers })
    this.state.presigned = s3Url2.data.presigned_urls
    // console.log("PresignedURL: ", s3Url2.data.presigned_urls)
    // console.log("State attachments", this.state.attachments)

  }

  renderLoader() {
    return (
      <>
        <div className='triangles'>
          <div className='tri invert'></div>
          <div className='tri invert'></div>
          <div className='tri'></div>
          <div className='tri invert'></div>
          <div className='tri invert'></div>
          <div className='tri'></div>
          <div className='tri invert'></div>
          <div className='tri'></div>
          <div className='tri invert'></div>
        </div>
      </>
    )
  }

  render() {
    const { title, isOfficeInitialized } = this.props;
    const { id, documentTypes, permissionsData } = this.state;

    if (!isOfficeInitialized) {
      return (
        <Progress
          title={title}
          logo={require("./../../../assets/logo-filled.png")}
          message="Please sideload your addin to see app body."
        />
      );
    }

    const item = Office.context.mailbox?.item;

    if (permissionsData === null) {
      return (
        <>
          {this.renderLoader()}
        </>
      )
    }
    return item ? (
      <>
        <Container maxWidth="sm">
          <CustomTextField pt={2}
            label="FROM"
            defaultValue={item.from.displayName || ""}
            fontSize={fontSize}
            inputProps={{ readOnly: true, disableUnderline: false }}
          />
          <CustomTextField
            label="SUBJECT"
            defaultValue={item.subject || ""}
            fontSize={fontSize}
            inputProps={{ readOnly: false, disableUnderline: false }}
          />
          {/* <CustomTextField label="CC" fontSize={fontSize} inputProps={{ readOnly: false, disableUnderline: false }} /> */}
          <CustomSelect
            disabled={this.state.documentType !== ""}
            value={this.state.documentType}
            label="DOCUMENT TYPE"
            mailItem={item}
            menuItem={getDocumentType(permissionsData)}
            // menuItem={documentTypes}
            onChangeFunc={this.onChangedocumentType}
            onBlurFunc={this.validateFields}
            helperText={this.state.documentType ? "To Change the Document Type, Please re-open" : ""}
            error={this.state.documentTypeInvalid}

          />
          {this.state.documentType && (
            <>
              <>
                {this.renderContent()}
              </>
              <CustomTextField
                label="MAIL BODY"
                defaultValue={this.state.mailContent || ""}
                fontSize={fontSize}
                rows={7}
                onBlurFunc={this.validateFields}
                inputProps={{ readOnly: false, disableUnderline: false }}
              />
              <CustomCheckbox
                label="ATTACHMENTS"
                checkboxitems={this.state.attachments}
                onChangeFunc={this.updateAttachments}
                defaultChecked={true}
                disabled={true}
              />
              <>
                {this.renderAttachmentInfo()}
              </>
            </>
          )}
          <Box pb={4}>
            <Box pt={2} pb={1}>
              <Button fullWidth variant="outlined" onClick={this.resetState}>
                Reset
              </Button>
            </Box>
            {!this.state.mailSentSuccessfully && (
              <>
                <Box pt={1}>
                  <Button fullWidth variant="contained" onClick={(e) => this.uploadAttachment_alt(item)}>
                    Upload
                  </Button>
                </Box>

                {this.state.uploadStarted && !this.state.uploadEnded && (
                  <Box pt={1} sx={{ width: '100%' }}>
                    <LinearProgress />
                  </Box>
                )}
                <Box pt={1} pb={0.5}>
                  <Button
                    fullWidth
                    variant="contained"
                    disabled={!this.state.uploadEnded || this.state.policysymbolInvalid || this.state.policynumberInvalid || this.state.identifierInvalid || this.state.agencynumberInvalid || this.state.beaconsystempolicynumberInvalid || this.state.bondspolicynumberInvalid || this.state.locationInvalid || this.state.completepolicynumberInvalid || this.state.insurednameInvalid || this.state.producercodeInvalid || this.state.rtwpolicynumberInvallse || this.state.checkrangeInvalid || this.state.ssnInvalid || this.state.producernumberInvalid || this.state.useridInvalid || this.state.yearInvalid || this.state.internalaudituseridInvalid || this.state.rhodepolicynumberInvalid || this.state.doctypepolicynumberInvalid}
                    onClick={(e) => this.sendToSACC(item, this.state.documentType, this.state)}
                    endIcon={<SendIcon />}
                  >
                    Send to SACC
                  </Button>
                </Box>
              </>
            )}
            {this.state.mailSending && !this.state.mailSentSuccessfully && (
              <Box pb={5} pt={0.5} sx={{ width: '100%' }}>
                <LinearProgress
                  color="success" />
              </Box>
            )}
            {this.state.mailSentSuccessfully && (
              <Button pt={2}
                fullWidth
                variant="contained"
                endIcon={<CheckCircleIcon />}
                color="success"
              ></Button>
            )}
          </Box>
        </Container>
      </>
    ) : (<>{this.renderLoader()}</>
    );
  }
}

App.propTypes = {
  title: PropTypes.string,
  isOfficeInitialized: PropTypes.bool,
};
